import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useAccountStatusCache } from './cache'
import { type AccountStatusRemoveInput, type AccountStatusRemoveSuccess, toResponseError } from '@terros/common'

export function useRemoveAccountStatus(): RemoveHookResponse<AccountStatusRemoveInput> {
  const { removeItem } = useAccountStatusCache()

  const mutation = useTantalimMutation<AccountStatusRemoveInput, AccountStatusRemoveSuccess>({
    url: '/account/status/remove',
  })

  async function remove(input: AccountStatusRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      removeItem(input.statusId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
